import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { QueryClientProvider } from "@tanstack/react-query";

import { TimezoneProvider, setupDayjs } from "contexts";

import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./auth/AuthProvider";
import { useSignOutOnIdle } from "./auth/hooks/useSignOutOnIdle/useSignOutOnIdle";
import { WebSocketProvider } from "./common/contexts/WebsocketContext/WebsocketContext";
import { Routes } from "./routes/Routes";
import { queryClient, supabase } from "./services";

setupDayjs();

export function App() {
  const checkComplete = useSignOutOnIdle();

  if (!checkComplete) return null;

  return (
    <BrowserRouter>
      <WebSocketProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <QueryClientProvider client={queryClient}>
            <TimezoneProvider>
              <AuthProvider supabaseClient={supabase}>
                <Routes />
              </AuthProvider>
            </TimezoneProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </WebSocketProvider>
    </BrowserRouter>
  );
}

export default App;
